import React from 'react';
import SvgIcon from './svg-icon.jsx';

export default function UserAvatarIcon({
  className = '',
  width = 17,
  height = 16,
  title,
  ...props
}) {
  return (
    <SvgIcon
      name="user"
      viewBox="0 0 17 16"
      width={width}
      height={height}
      className={['user-avatar-icon', className].filter(Boolean).join(' ')}
      title={title}
      {...props}
    />
  );
}
